// extracted by mini-css-extract-plugin
export default {"basketContent":"Basket_basketContent__Wa27d","subtitle":"Basket_subtitle__IVp5m","totalSum":"Basket_totalSum__H8hma"};